import { useEffect, useState } from 'react';
import api from '../services/api';

export const useLiveCoupon = () => {
  const [coupon, setCoupon] = useState(null);
  const [visible, setVisible] = useState(false);
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchLiveCoupon = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await api.getLiveCoupon();
      setCoupon(data.coupon || null);
      setVisible(Boolean(data.visible));
      setEnabled(Boolean(data.enabled));
    } catch (err) {
      if (String(err?.message || '').includes('JSON yerine HTML')) {
        setCoupon(null);
        setVisible(false);
        setEnabled(false);
        setError(null);
      } else {
        setError(err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLiveCoupon();
  }, []);

  return {
    coupon,
    visible,
    enabled,
    loading,
    error,
    refetch: fetchLiveCoupon
  };
};
